import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        title: {
            padding: theme.spacing(6, 0, 1.5),
        },
    }
})
